/**
 * Sections d'informations affichées dans la prévisualisation d'un mandat (CertificateDisplay)
 * Décrites côté serveur dans SMAAttribute (DisplayedInformations)
 */
enum SMADisplayInformationEnum
{
    General = 1,
    Meters = 2,
    Customer = 3,
    Historic = 4,
    Appendixes = 5
}

export default SMADisplayInformationEnum;
